export default "__VITE_ASSET__BobpdL6Y__"